import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
